const RUSSIAN_TIMEZONES = [
    'Europe/Moscow',
    'Europe/Samara',
    'Europe/Volgograd',
    'Europe/Kaliningrad',
    'Europe/Kirov',
    'Europe/Astrakhan',
    'Europe/Saratov',
    'Europe/Ulyanovsk',
    'Asia/Yekaterinburg',
    'Asia/Omsk',
    'Asia/Novosibirsk',
    'Asia/Barnaul',
    'Asia/Tomsk',
    'Asia/Novokuznetsk',
    'Asia/Krasnoyarsk',
    'Asia/Irkutsk',
    'Asia/Chita',
    'Asia/Yakutsk',
    'Asia/Khandyga',
    'Asia/Vladivostok',
    'Asia/Ust-Nera',
    'Asia/Magadan',
    'Asia/Sakhalin',
    'Asia/Srednekolymsk',
    'Asia/Kamchatka',
    'Asia/Anadyr',
]

export function isRussianUser(): boolean {
    try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        return RUSSIAN_TIMEZONES.includes(timezone)
    } catch {
        return false
    }
}
